const m05Section = {
  id: 'm05',
  name: '2027ScoresheetM05Sub1Label',
  fields: [
    {
      scoring: "2027ScoresheetM05Sub2Label",
      id: 'm05_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: 0
        },
        {
          description: 'partiallyLabel',
          value: 1
        },
        {
          description: 'completelyLabel',
          value: 2
        }
      ]
    },
  ]
}

export default m05Section;